import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const MembershipScheme = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Membership Scheme</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) Membership Scheme provides organizations and stakeholders 
            with opportunities to engage, access resources, and participate in standardization activities.
          </p>
          <p className="subtitle">
            Membership strengthens collaboration, enhances knowledge sharing, and promotes compliance with national and international standards.
          </p>
        </div>
      </section>

      {/* === Membership Benefits Section === */}
      <section className="intro-section">
        <h2 className="section-title">Benefits of Membership</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Access to national and international standards documents</li>
              <li>Participation in technical committees and standard development processes</li>
              <li>Opportunities for training and capacity building</li>
              <li>Regular updates on standards, regulations, and industry developments</li>
              <li>Networking with industry peers and regulatory bodies</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Priority access to workshops, seminars, and conferences</li>
              <li>Recognition as a contributor to quality and standards compliance</li>
              <li>Support and guidance on standards implementation</li>
              <li>Enhanced credibility and competitiveness in the market</li>
              <li>Subscription to MBS newsletters and publications</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Membership Categories Section === */}
      <section className="functions-section">
        <h2 className="section-title">Membership Categories</h2>
        <p>
          MBS offers various membership categories to suit different types of organizations, including:
        </p>
        <ul>
          <li>Corporate Membership for companies and industries</li>
          <li>Individual Membership for professionals and experts</li>
          <li>Institutional Membership for educational and research organizations</li>
          <li>Government and Regulatory Body Membership</li>
        </ul>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Membership</h2>
        <p>
          For inquiries, registration, or further information about the MBS Membership Scheme, please contact the Membership Department.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:membership@mbs.mw">membership@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 222</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The MBS Membership Scheme connects stakeholders, enhances knowledge, and promotes adherence to high-quality standards in Malawi.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default MembershipScheme;
